import { logger } from '@sentry/react';
import { DBMessageType, SWMessageType } from './types';

export const listenToSWMessages = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener(
      'message',
      handleServiceWorkerMessage
    );
  }
};

const DB_ERROR_FALLBACKS: Record<DBMessageType, string> = {
  DB_PUT_FAILED: 'IndexedDB put() failed',
  DB_GET_FAILED: 'IndexedDB get() failed'
};

export const handleServiceWorkerMessage = (event: MessageEvent) => {
  const data = event.data as SWMessageType | undefined;
  if (!data) return;

  switch (data.type) {
    case 'UNLEASH_CACHE_FALLBACK':
      logWarning(
        data.message ?? 'Unleash request failed, served from cache',
        data.data ?? 'unknown data'
      );
      break;

    case 'DB_PUT_FAILED':
    case 'DB_GET_FAILED':
      logError(data.message ?? DB_ERROR_FALLBACKS[data.type]);
      break;

    default:
      break;
  }
};

const logWarning = (message: string, data: string) => {
  console.warn(message, { data });
  logger.warn(message, { data });
};

const logError = (message: string) => {
  logger.error(message);
};
